import api from "../../apis";

export const facebookLogin = async () => {
  try {
    const response = await api.post("/oauth/facebook/generate", {});
    return response.data.link;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};

export const facebookOAuthAPI = async (state, code, error, error_description) => {
  try {
    const response = await api.get(`/oauth/facebook?state=${state}&code=${code}&error=${error}&error_description=${error_description}`);
    return response;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
